<script>
import DOMUtils from '@/utils/DOMUtils'

const REF_BACKGROUND_HALF_CIRLCE = 'background-half-circle'
const REF_RECTANGULAR_FRAME = 'rectangular-frame'

export default
{
    name: 'background-half-circle',

    props:
    {
        settings: { default: () => { return { height: '0px', extraPadding: '0px' } } },
        settingsMobile: { default: () => { return { height: undefined, extraPadding: undefined } } },
        settingsTablet: { default: () => { return { height: undefined, extraPadding: undefined } } },
        settingsDesktop: { default: () => { return { height: undefined, extraPadding: undefined } } },
    },

    created ()
    {
        window.addEventListener('resize', this.onWindowResized);
    },

    render () 
    {
        return (
            <div id='background-half-circle' ref={REF_BACKGROUND_HALF_CIRLCE}>
                <div id='rectangular-frame' ref={REF_RECTANGULAR_FRAME} />
                <div id='half-circle' />
            </div>
        )
    },

    mounted ()
    {
        this.onWindowResized()
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        backgroundHalfCircle ()
        {
            return this.$refs[REF_BACKGROUND_HALF_CIRLCE]
        },

        rectangularFrame ()
        {
            return this.$refs[REF_RECTANGULAR_FRAME]
        }
    },

    methods:
    {
        onWindowResized ()
        {
            const mediaName = DOMUtils.getMatchingMediaName()
            
            let settings
            switch (mediaName)
            {
                case 'mobile':
                    settings = this.settingsMobile
                    break;
                case 'tablet':
                    settings = this.settingsTablet
                    break;
                case 'desktop':
                    settings = this.settingsDesktop
                    break;
            }
            settings.height = settings.height || this.settings.height
            settings.extraPadding = settings.extraPadding || this.settings.extraPadding

            this.backgroundHalfCircle.style.top = settings.extraPadding
            this.rectangularFrame.style.paddingTop = settings.height
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#background-half-circle
{
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;

    #rectangular-frame
    {
        width: 100%;
        background: var(--theme-accent-color);
        position: relative;
        z-index: -1;
    }

    #half-circle
    {
        position: relative;
        z-index: -2;
        width: 100vw;
        height: 50vw;
        margin-top: -35vw;
        background-color: var(--theme-accent-color);
        mask: var(--theme-half-circle-path) no-repeat center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/BackgroundHalfCircle.vue